import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DonorListComponent } from './donor-list/donor-list.component';
import { DonorDetailsComponent } from './donor-details/donor-details.component';


const routes: Routes = [
  { path: '', component: DonorListComponent },
  { path: 'donor-list', component: DonorListComponent },
  { path: 'donor-list/:id', component: DonorDetailsComponent }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DonorRoutingModule { }
